const initState = {
    activeStudioId: "",
    reservations: [
    ]
}
const studioReducer = (state = initState, action) => {
    switch (action.type) {
        case 'SET_ACTIVE_STUDIO':
            state.activeStudioId = action.activeStudioId;
            console.log("just set active studio id")
            if (state.reservations && state.reservations.length > 0) {
                console.log("hola")
                state.reservations = state.reservations.filter(val => {
                    if (val.studio_id == null) {
                        return false;
                    }
                    return val.studio_id === state.activeStudioId;
                });
            } else {
                state.reservations = []
            }
            return state;
        case 'GET_RESERVATIONS':
            state.reservations = action.reservations.filter(val => {
                if (val.studio_id == null) {
                    return false;
                }
                return val.studio_id === state.activeStudioId;
            });
            return state;
        default:
            break;
    }

    return state
}

export default studioReducer;